<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.getAll();
    this.$store.dispatch("lookups/getMedicines");
    this.$store.dispatch("lookups/getStores");

},
computed: {
  stores() {
    return [
      { value: 0, label: "الكل" },
      ...this.$store.state.lookups.stores]
  },
    pageCount() {
      return Math.ceil(
        this.$store.state.inventory.totalItems / this.filters.pageSize
      );
    },
    inventory() {
      return this.$store.state.inventory.inventory;
    },
    medicines() {
      return [
        { value: 0, label: "الكل" },
        ...this.$store.state.lookups.medicines
      ]
    }

  },

  data() {
    return {
      permissions: this.$inventoryManagementPermissions.inventoryPermissions,

      view: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        expirationDate: null,
        medicineId: null,
        storeId: 0,

      },
      headers: [
        { text: 'اسم الدواء', value: 'medicineName' },
        { text: ' المخزن ', value: 'storeName' },

        { text: 'اجمالى الكمية ', value: 'quantity' },
        { text: 'الكمية المتاحة', value: 'remainingQuantity' },
        { text: 'تاريخ انتهاء الصلاحية ', value: 'expirationDate' },
        { text: 'رقم التشغيلة ', value: 'batchNo' },
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        // { text: "تاريخ التسجيل", value: "createdOn", sortable: false },
        // { text: 'الاجراءات', value: 'actions', sortable: false },
      ],

      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("inventory/getAll", this.filters);

    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      // Implement view logic
    },
    handleClear() {
      this.filters.expirationDate = null;
    },

    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>